import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { config } from '../config';


import { Router } from '@angular/router';
import { timeout } from 'rxjs/operators';
import { Wait } from '../util/timeout';
import { Cacheable } from 'ngx-cacheable';

@Injectable({
  providedIn: 'root',
})
export class VehiclesService {

  constructor(private http: HttpClient,private router: Router) { }
  
  getFiltered(filter: {
    plate: string,
    rfid: string,
    manufacturer: string,
    model: string,
    color: string
    building: string,
    floor: string,
    unit: string,
    unitName: string,
    viewSensitiveUserData: boolean,
    geolocation: string
  }): Observable<[]> {
    
    let params = new HttpParams()
      .set("plate", filter.plate)
      .set("veicleRfid", filter.rfid)
      .set("manufacturer", filter.manufacturer)
      .set("model", filter.model)
      .set("color", filter.color)
      .set("building", filter.building)
      .set("floor", filter.floor)
      .set("unit", filter.unit)
      .set("unitName", filter.unitName)
      .set("viewSensitiveUserData", filter.viewSensitiveUserData.toString())
      .set("geolocation", filter.geolocation);

    return this.http.get<any>(`${config.apiUrl}/Vehicle/filtered`, {params: params})
      .pipe(timeout(Wait),
        tap(resp => resp),
        catchError(error => {
          console.log(error.error);
          return of([]);
        }));
  }

  getColors(): Observable<any> {
    return this.http.get<any>(`${config.apiUrl}/VehicleColors`)
      .pipe(timeout(Wait),
        tap(resp => resp),
        catchError(error => {
          console.log(error.error);
          return of([]);
        }));
  }

  @Cacheable({
    maxCacheCount: 2000,
    maxAge: 86_400,
  })
  getModels(): Observable<any> {
    return this.http.get<any>(`${config.apiUrl}/VehicleManufacturers`)
      .pipe(timeout(Wait),
        tap(resp => resp),
        catchError(error => {
          console.log(error.error);
          return of([]);
        }));
  }

  getVehicleByPlate(plate: string, userId: number): Observable<[]> {
    if (userId == undefined) {
      return this.http.get<any>(`${config.apiUrl}/Vehicle/GetPlates/${plate}`)
        .pipe(timeout(Wait),
          tap(resp => resp),
          catchError(error => {
            console.log(error.error);
            return of([]);
          }));
    }
    else {
      return this.http.get<any>(`${config.apiUrl}/Vehicle/GetPlates/${plate}/${userId}`)
        .pipe(timeout(Wait),
          tap(resp => resp),
          catchError(error => {
            console.log(error.error);
            return of([]);
          }));
    }
  }

  getVehicleByRfId(rfid: string, userId: number): Observable<[]> {
    if (userId == undefined) {
      userId = -1
    }
    return this.http.get<any>(`${config.apiUrl}/Vehicle/GetRfId/${rfid}/${userId}`)
    .pipe(timeout(Wait),
      tap(resp => resp),
      catchError(error => {
        console.log(error.error);
        return of([]);
      }));
  }

  getVehicleByRemoteControl(remoteControl: string, userId: number): Observable<[]> {
    if (userId == undefined) {
      userId = -1
    }
    return this.http.get<any>(`${config.apiUrl}/Vehicle/GetRemoteControl/${remoteControl}/${userId}`)
    .pipe(timeout(Wait),
      tap(resp => resp),
      catchError(error => {
        console.log(error.error);
        return of([]);
      }));
  }

}
